import { useActionless, useAppSelector } from 'redux/hooks'
import { usePinnedInteractions } from 'hooks/usePinnedSidecar'

import { SET_ACTIVE_STATE } from 'redux/active/actions/types'
import { selectOwnsDeck } from 'redux/deck/selectors'

import Editor from 'components/formElements/richText/Editor'
import CommentContainer from 'components/deckPage/CommentContainer'
import PhatButton from 'components/formElements/PhatButton'

import { isEmpty } from 'utils/Deltas'

import styles from './interactionContainer.module.scss'

type Props = {
  className?: string
}

const InteractionContainer = ({ className = '' }: Props) => {
  const description = useAppSelector(state => state.deck.description)
  const ownsDeck = useAppSelector(selectOwnsDeck)

  const [pinnedInteractionStatus, setPinnedInteractionStatus] = usePinnedInteractions()

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.description}>
        <div className={styles.header}>
          <h2>Description</h2>
          {ownsDeck && (
            <PhatButton icon="edit outline" onClick={() => setActiveState({ modals: { 'description': true } })}>
              Edit description
            </PhatButton>
          )}
        </div>

        {isEmpty(description) ? (
          <p className={styles.empty}>This deck has no description</p>
        ) : (
          <Editor className={styles.description} value={description} readOnly />
        )}
      </div>

      <div className={styles.commentBlock}>
        <div className={styles.commentControls}>
          <PhatButton
            icon="columns"
            onClick={() => {
              setActiveState({ interactionOverlay: false })

              setPinnedInteractionStatus({
                ...pinnedInteractionStatus,
                locked: !pinnedInteractionStatus.locked,
                open: false,
              })
            }}>
            {pinnedInteractionStatus.locked ? 'Unpin' : 'Pin'} above
          </PhatButton>
        </div>

        <CommentContainer noHeader className={styles.comment} />
      </div>
    </div>
  )
}

export default InteractionContainer
